export const baseURL = "https://lovcam.in";
export const secretKey = "3z9Z#KQd%YxRLmNop&Tg8hBwjvVfA!72PX@dM5";
export const  projectName = "lovcam";
